import { useEffect } from 'react';
import { INCHES_PER_METER } from './useMapScale';

export default function useDpi (DEFAULT_DPI = 96) {
    const elementId = 'inchSquare';
    let inchSquare = document.getElementById(elementId);
    if (!inchSquare) {
        inchSquare = document.createElement('div');
        inchSquare.id = 'inchSquare';
        inchSquare.style.visibility = 'hidden';
        inchSquare.style.position = 'absolute';
        inchSquare.style.width = '1in';
        inchSquare.style.height = '1in';
        document.body.appendChild(inchSquare);
    }

    const calculatedDpi = inchSquare.clientWidth;
    const dpi = calculatedDpi || DEFAULT_DPI;

    const getResolutionFromScale = (scale) => {
        return scale / (INCHES_PER_METER * dpi);
    };

    useEffect(() => {
        return () => {
            const element = document.getElementById(elementId);
            if (document.body.contains(element)) {
                document.body.removeChild(element);
            }
        };
    }, []);

    return {
        dpi,
        getResolutionFromScale
    };
};
